module.exports = __webpack_public_path__ + "img/de_de.fea0e126.png";